import React, { useState } from "react";
import Style from "./Warning.module.css";
import { CiLogout } from "react-icons/ci";
import { useEditChannelAction } from "../../../hooks/useChannel";
import { getRegisterId } from "../../../utils/authId";
import { storeSelectedActivity, storeSelectedDms } from "../../../utils/auth";

const LeaveConfirmation = ({
  itemName = "",
  onClose,
  channelId,
  update = "",
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    editActionChannel,
    // isLoading: isEditLoading
  } = useEditChannelAction(channelId);
  const redId = getRegisterId();
  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await editActionChannel({ leave_people: redId });
      storeSelectedDms({});
      storeSelectedActivity({});
      onClose();
      update();
      localStorage.removeItem("selectedperson");
      localStorage.removeItem("seletedactivity");
    } catch (error) {}
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <CiLogout size={50} color="red" />
          </div>

          <h3>Leave "{itemName}"?</h3>
          <p className={Style.Warrningpara}>This action cannot be undone.</p>

          <div className={Style.WarningbuttonGroup}>
            <button
              className={Style.WarningcancelBtn}
              onClick={handleCancel}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              className={`${Style.WarningdeleteBtn} ${
                isDeleting ? Style.Warningdeleting : ""
              }`}
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <div className={Style.Warningspinner}></div>
              ) : (
                "Leave"
              )}
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default LeaveConfirmation;
